import { Pipe, PipeTransform } from '@angular/core';

/**
 * Time from now pipe.
 */
@Pipe({
  name: 'timeAgo',
  pure: false,
  standalone: false,
})
export class TimeAgoPipe implements PipeTransform {
  /**
   * Implementation of PipeTransform function
   * @param value Date to transform
   */
  public transform(value: Date | string) {
    if (!value) return '';

    const now = new Date().getTime();
    const date = new Date(value.toString());
    const valueTime = date.getTime();

    const seconds = Math.abs(now - valueTime) / 1000;

    if (Number.isNaN(seconds) || seconds < 60) {
      return $localize`:Ui library|Now label@@timePassedNowLabel:Now`;
    }

    const minutes = Math.round(Math.abs(seconds / 60));
    if (minutes < 60) {
      return $localize`:dates|Time ago@@datesTimeAgoMinutes:${minutes}min`;
    }

    const hours = Math.round(Math.abs(minutes / 60));
    if (hours < 24) {
      return $localize`:dates|Time ago@@datesTimeAgoHours:${hours}hr`;
    }

    const days = Math.round(Math.abs(hours / 24));
    if (days < 7) {
      return $localize`:dates|Time ago@@datesTimeAgoDays:${days}d`;
    }

    const weeks = Math.round(Math.abs(days / 7));
    if (days < 31) {
      return $localize`:dates|Time ago@@datesTimeAgoWeeks:${weeks}w`;
    }

    const months = Math.round(Math.abs(days / 30.416));
    if (days <= 365) {
      return $localize`:dates|Time ago@@datesTimeAgoMonths:${months}mon`;
    }

    const years = Math.round(Math.abs(months / 12));
    return $localize`:dates|Time ago@@datesTimeAgoYears:${years}y`;
  }
}
